module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-element-step",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('div', {
    class: _vm.themeClasses
  }, [_c('div', {
    staticClass: "mt-step-desc"
  }, [_vm._t("desc", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.desc)
    }
  })])], 2), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a7ab258"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/step/step-panel.vue
// module id = 666
// module chunks = 85